import React, { useEffect, useState } from 'react';
import { DATE_TODAY } from '@/constants';
import styled, { css } from 'styled-components';

const headerFooterCSS = css`
  display: none;
  width: 100%;
  text-align: right;

  @media print {
    display: block;
    position: fixed;

    @media not all and (min-resolution: 0.001dpcm) {
      @supports (-webkit-appearance: none) {
        position: unset;
      }
    }
  }
`;

const PrintHeader = styled.header`
  ${headerFooterCSS}
  top: 0;
`;

const PrintFooter = styled.footer`
  ${headerFooterCSS}
  bottom: 0;
`;

const PrintTable = styled.table`
  width: 100%;

  /* thead {
    display: none;

    @media print {
      display: table-header-group;
    }
  }

  tfoot {
    display: none;

    @media print {
      display: table-footer-group;
    }
  } */
`;

const ReservedSpace = styled.div`
  @media print {
    height: 0.5in;
  }
`;

function TableRowTableDataComponent({ children }) {
  return (
    <tr>
      <td>{children}</td>
    </tr>
  );
}

/**
 * https://stackoverflow.com/a/64599494/13426922
 * This component is used to add a header and footer to each printed page
 * The "thead" and "tfoot" component are invisible blocks of reserved spaced
 *    for "PrintHeader" and "PrintFooter" to utilize
 *
 * "PrintHeader" and "PrintFooter" will take the space reserved by "thead" and "tfoot"
 *    via CSS (position: fixed, top/bottom: 0)
 */
export function PrintWrapper(props) {
  const [time, setTime] = useState(DATE_TODAY.toLocaleTimeString());

  useEffect(() => {
    const interval = setInterval(() => {
      const dateTimeRightNow = new Date();
      setTime(dateTimeRightNow.toLocaleTimeString());
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div>
      <PrintTable>
        {/*
          Hidden for now until it needs to be used
          <thead>
            <TableRowTableDataComponent>
              <ReservedSpace>&nbsp;</ReservedSpace>
            </TableRowTableDataComponent>
          </thead>
        */}

        <tbody>
          <TableRowTableDataComponent>
            <div>{props.children}</div>
          </TableRowTableDataComponent>
        </tbody>

        <tfoot>
          <TableRowTableDataComponent>
            <ReservedSpace>&nbsp;</ReservedSpace>
          </TableRowTableDataComponent>
        </tfoot>
      </PrintTable>

      <PrintHeader></PrintHeader>
      <PrintFooter>
        Rentalscape Property Overview - {DATE_TODAY.toLocaleDateString()} /{' '}
        {time}
      </PrintFooter>
    </div>
  );
}
